import styled from "styled-components";
import {
  mediaMaxWidth,
  mediaMaxHeight,
  mediaMinWidth,
} from "../../../theme/mediaQueriesTemplates";

export const ModalBackdrop = styled.div`
  background-color: rgba(0, 0, 0, 0.6);
  height: 100vh;
  width: 100vw;
  position: fixed;
  left: 0;
  top: 0;
  z-index: 6;
  display: flex;
  justify-content: center;
  align-items: center;

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  &.animated {
    animation-duration: 0.5s;
    animation-fill-mode: both;
  }

  &.fadeIn {
    animation-name: fadeIn;
  }

  ${mediaMaxHeight.phone} {
    align-items: unset;
  }

  ${mediaMaxWidth.tablet} {
    align-items: unset;
  }
`;

export const Modal = styled.div`
  background-color: #ffffff;
  border-radius: 8px;
  width: 800px;
  height: 550px;
  z-index: 5;
  overflow: hidden;
  padding: 10px 20px;
  position: relative;
  margin-left: 60px;

  .animated {
    animation-duration: 0.4s;
    animation-fill-mode: both;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  .fadeInUp {
    animation-name: fadeInUp;
  }

  .delay1 {
    animation-delay: 0.1s;
  }

  .delay2 {
    animation-delay: 0.25s;
  }

  .delay3 {
    animation-delay: 0.35s;
  }

  .delay4 {
    animation-delay: 0.5s;
  }

  .delay5 {
    animation-delay: 0.6s;
  }

  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translate3d(0, 100%, 0);
    }

    to {
      opacity: 1;
      transform: translate3d(0, 0, 0);
    }
  }

  &.animated {
    animation-duration: 0.3s;
    animation-fill-mode: both;
  }

  &.fadeInUp {
    animation-name: fadeInUp;
  }

  &.delay {
    animation-delay: 0.1s;
  }

  ${mediaMaxWidth.smallDesktop} {
    margin-left: unset;
    width: calc(100vw - 30px);
  }

  ${mediaMaxWidth.tablet} {
    top: 10px;
    height: 530px;
  }

  ${mediaMaxWidth.phone} {
    width: calc(100vw - 20px);
    padding: 10px 10px;
  }

  ${mediaMaxHeight.phone} {
    top: 10px;
  }

  ${mediaMaxWidth.smallPhone} {
    height: 460px;
  }
`;

export const Title = styled.div`
  border-bottom: 1px solid #d8d8d8;
  color: #343333;
  font-weight: 600;
  font-size: 1em;
  padding: 5px 10px;
  margin: 7px 0;
  display: flex;
  justify-content: space-between;
`;

export const TitleText = styled.div`
  width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;

  ${mediaMinWidth.smallDesktop} {
    width: 95%;
  }
`;

export const CloseButton = styled.div`
  cursor: pointer;

  svg {
    color: #a0a0a0;
    font-size: 1.2em;
    transition: 0.1s ease-in-out;

    &:hover {
      color: #402680;
    }
  }
`;

export const BodyWrapper = styled.div`
  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }

  &.animated {
    animation-duration: 1s;
    animation-fill-mode: both;
  }

  &.fadeIn {
    animation-name: fadeIn;
  }
`;

export const Body = styled.div`
  overflow: scroll;
  padding: 10px;
  display: flex;
  flex-direction: row;

  ${mediaMaxWidth.tablet} {
    height: 450px;
  }

  ${mediaMaxWidth.smallTablet} {
    flex-direction: column;
  }

  ${mediaMaxWidth.smallPhone} {
    height: 390px;
  }
`;

export const Left = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-right: 20px;

  ${mediaMaxWidth.smallTablet} {
    margin-right: 0;
  }
`;

export const Right = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-left: 20px;

  ${mediaMaxWidth.smallTablet} {
    margin-left: 0;
    margin-top: 50px;
  }
`;

export const Subtitle = styled.div`
  font-weight: 600;
  font-size: 0.8em;
  margin: 5px 0 10px 0;
`;

export const Receipt = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
`;

export const Line = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 4px 0;
`;

interface IItemProps {
  total?: boolean;
}

export const Item = styled.div`
  color: ${(props: IItemProps) => (props.total ? "#333" : "#9c9c9c")};
  font-weight: ${(props: IItemProps) => (props.total ? "600" : "400")};
  font-size: ${(props: IItemProps) => (props.total ? "1em" : "0.85em")};
  display: flex;
  flex-direction: column;
`;

interface IValueProps {
  total?: boolean;
}

export const Value = styled.div`
  font-weight: ${(props: IValueProps) => (props.total ? "600" : "500")};
  font-size: ${(props: IValueProps) => (props.total ? "1em" : "0.85em")};
  color: #7d7d7d;
`;

export const Separator = styled.div`
  border-top: 1px solid #d8d8d8;
  margin: 15px 0;
`;

interface IPriceProps {
  bold?: boolean;
}

export const Price = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  color: ${(props: IPriceProps) => props.bold && "#333"};
`;

export const VAT = styled.div`
  display: flex;
  font-weight: 400;
  font-size: 0.75em;
  color: #9c9c9c;
`;

interface INewPriceProps {
  bold?: boolean;
}

export const NewPrice = styled.div`
  display: flex;
  color: ${(props: INewPriceProps) => props.bold && "#333"};
`;

export const OldPrice = styled.div`
  text-decoration: line-through;
  font-size: 0.75em;
  font-weight: 400;
  padding: 3px 7px 0 0;
  color: #9c9c9c;
`;

export const BillingPeriod = styled.div`
  font-weight: 400;
  color: #9c9c9c;
  font-size: 0.75em;
`;

export const CardData = styled.div`
  margin-right: 20px;
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  height: 100%;
  color: #9c9c9c;

  ${mediaMaxWidth.smallTablet} {
    margin-bottom: 0;
    margin-right: 0;
  }
`;
